<form class="p-fluid" [formGroup]="levelAdjustmentForm">
  <div class="field">
    <label class="field-required">Select Date:</label>
    <div class="p-field-value mb-2">
      <p-date-picker
        formControlName="dateRange"
        selectionMode="range"
        appendTo="body"
        placeholder="Select"
        styleClass="form-control"
        [readonlyInput]="true"
        [showIcon]="true"
        [minDate]="minDate"
        [maxDate]="maxDate"
      ></p-date-picker>
      <errors-messages [control]="levelAdjustmentForm?.get('dateRange')"></errors-messages>
    </div>
    @if (levelAdjustmentForm?.get('dateRange')?.hasError('isOverlap')) {
      <p-message
        severity="warn"
        text="Reimbursement level within this date range already exists. Please choose a different date range."
        class="suggested-message"
        >
      </p-message>
    }
  </div>
  <div class="field">
    <label class="field-required">Level of Care:</label>
    <div class="p-field-value">
      <p-select
        formControlName="levelOfCare"
        placeholder="Select"
        appendTo="body"
        styleClass="form-control"
        [options]="levelOfCare"
      ></p-select>
      <errors-messages [control]="levelAdjustmentForm?.get('levelOfCare')"></errors-messages>
    </div>
  </div>
</form>

<div class="flex justify-end mt-4">
  <button
    class="mr-2 p-button p-button-secondary"
    pButton
    label="Cancel"
    (click)="onCancel()"
  ></button>
  <button
    pButton
    label="Add"
    [disabled]="levelAdjustmentForm?.invalid"
    (click)="onSave()"
  ></button>
</div>
